module.exports = __webpack_public_path__ + "img/618-42dfb3.png";